import initializeLoanCalc from './housingLoanCalculator';
import initializeMortgageCalculatorEffectiveRate from './mortgageCalculatorEffectiveRate';

import './styles/index.scss';

const domHooksForHousingCalcPenni = {
    main_holder: 'housing-loan-calculator',
    inputs: {
        PropertyValue: 'PropertyValue',
        LoanAmount: 'LoanAmount',
        LoanTerm: 'LoanTerm',
        MonthlyFee: 'MonthlyFee',
        EstablishmentFee: 'EstablishmentFee',
    },
    result: {
        loan_ratio: 'loan_ratio',
        ratio_container: 'ratio_container',
        loan_ratio_err: 'loan_ratio_err',
        monthly_cost: 'monthly_cost',
        rate_effective: 'rate_effective',
        rate_nominal: 'rate_nominal',
    },
    resultHolders: {
        success: 'js_calculator_success',
        reject: 'js_calculator_reject',
        error: 'js_calculator_error',
    },
};

const domHooksForGenericCalc = {
    main_holder: 'loan-calculator-generic',
    inputs: {
        EffectiveRate: 'EffRateGen',
        LoanAmount: 'LoanAmountGen',
        LoanTerm: 'LoanTermGen',
    },
    result: {
        monthly_cost: 'monthly_cost_generic',
        button_for_params: 'js-open-bank-chooser',
    },
    resultHolders: {
        success: 'js_calculator__generic_success',
    },
};

document.addEventListener('DOMContentLoaded', () => {
    initializeLoanCalc(domHooksForHousingCalcPenni);
    initializeMortgageCalculatorEffectiveRate(domHooksForGenericCalc);
});
